import { SetStateAction, useSetAtom, WritableAtom } from 'jotai';
import { CustomField } from 'src/admin/customFields/entities/customFields.entity';
import { Chip } from '../../Chips/Chip';
import {
  findCustomFieldDefinitionById,
  findCustomFieldOptionDefinitionById,
} from 'src/admin/customFields/utils/customFieldHelpers';

type DropdownCustomFieldChipsProps = {
  isLoading: boolean;
  customFieldDefinitions: CustomField[];
  customFieldDefinitionId: string;
  customFieldSelectedOptionIds: string[];
  customFieldsAtom: WritableAtom<
    Record<string, string | string[]>,
    [SetStateAction<Record<string, string | string[]>>],
    void
  >;
};

export const DropdownCustomFieldChips = ({
  customFieldDefinitions,
  customFieldDefinitionId,
  customFieldSelectedOptionIds,
  customFieldsAtom,
  isLoading,
}: DropdownCustomFieldChipsProps) => {
  const setCustomFields = useSetAtom(customFieldsAtom);
  const customFieldDefinition = findCustomFieldDefinitionById(
    customFieldDefinitions,
    customFieldDefinitionId,
  );

  if (!customFieldDefinition) {
    return null;
  }

  const customFieldName = customFieldDefinition.label;

  const handleDeleteChip = (id?: string) => {
    if (!id) {
      return;
    }

    setCustomFields((customFields) => {
      const prevFields = customFields[customFieldDefinitionId] as string[];
      return {
        ...customFields,
        [customFieldDefinitionId]: prevFields.filter((field) => field.toString() !== id),
      };
    });
  };

  return customFieldSelectedOptionIds.map((customFieldOptionDefinitionId) => {
    const customFieldOptionDefinition = findCustomFieldOptionDefinitionById(
      customFieldDefinition,
      customFieldOptionDefinitionId,
    );
    if (!customFieldOptionDefinition) {
      return null;
    }

    const customFieldOptionLabel = customFieldOptionDefinition.label;

    return (
      <Chip
        label={`${customFieldName}: ${customFieldOptionLabel}`}
        key={`${customFieldName}: ${customFieldOptionLabel}`}
        size="medium"
        variant="filled"
        isLoading={isLoading}
        onDelete={() => handleDeleteChip(customFieldOptionDefinition.id?.toString())}
      />
    );
  });
};
